import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { ignoreError } from '~/infra/utils';
export const baseBIEvent = ()=>({
        session_id: window._sessionId,
        viewport_height: window.innerHeight,
        viewport_width: window.innerWidth,
        release: GIT_SHA1,
        user_agent: window.navigator.userAgent
    });
export const sendBiViaBeacon = (data)=>{
    ignoreError(()=>{
        const blob = new Blob([
            JSON.stringify(_object_spread({}, baseBIEvent(), data))
        ], {
            type: 'application/json'
        });
        navigator.sendBeacon("".concat(window._apiGatewayHostname, "/bi/event"), blob);
    });
};
export const initializeLogBIEvent = (sendBeacon)=>{
    return (data)=>{
        var _window_debug;
        if ((_window_debug = window.debug) === null || _window_debug === void 0 ? void 0 : _window_debug.logbi) {
            // eslint-disable-next-line no-console
            console.log('BI', data);
        }
        sendBeacon(data);
    };
};
